import React from "react";
import { useTranslation } from "react-i18next";
import InstructionPageShell from "./InstructionPageShell";

export default function InstructionAppointmentList() {
  const { t } = useTranslation("instructions");

  return (
    <InstructionPageShell
      blockTitle={t("appointmentList.blockTitle")}
      pageTitle={t("appointmentList.pageTitle")}
      body={t("appointmentList.body")}
    />
  );
}
